const $ = jQuery = require('jquery');
import 'jquery-ui-bundle';
window.$ = window.jQuery = $

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

//import './algolia.js';
import './typesense.js';
import './helper.js';
import './window.loadings.js';
import './wishlist.js';
import './swiper.js';
import './lazy-modules.js';
import './landing.js';
import './location.js';
import './product.js';
import './checkout.js';
